import React from 'react'
import { Button } from 'src/business-types/grocery/components/Button';

type Props = {
    balance?: number;
    paymode: string;
    resPrice: string;
    onPaymodeChange: (mode: string) => void;
    onAmountChange: (val: string) => void;
    onConfirm: () => void;
    onClose: () => void;
};

function RefundCard({
    balance,
    paymode,
    resPrice,
    onPaymodeChange,
    onAmountChange,
    onConfirm,
    onClose,
}: Props) {
    let balanceNum = Number(balance || 0);
    const isZero = balance === 0;
    const isAdvance = balanceNum < 0;

    const displayAmount = Math.abs(balanceNum).toFixed(2);
    return (
        <div className="w-auto shrink-0 bg-white border border-slate-200 rounded-xl p-4 flex flex-col gap-4 self-start shadow-md">
            <div className="flex bg-slate-100 rounded-lg p-1 gap-1">
                {["Cash", "Card"].map((mode) => (
                    <button
                        key={mode}
                        onClick={() => onPaymodeChange(mode)}
                        className={[
                            "flex-1 py-1.5 rounded-md text-sm font-medium transition-all",
                            paymode === mode
                                ? "bg-white text-slate-800 shadow-sm font-semibold"
                                : "text-slate-500 hover:text-slate-700",
                        ].join(" ")}
                    >
                        {mode}
                    </button>
                ))}
            </div>
            {isAdvance ? <div className='flex gap-2 justify-start items-end h-fit w-full'>
                <div className="flex flex-col gap-1.5 ">
                    <label className="text-[11px] text-slate-500 uppercase tracking-wider">
                        Refund{" "}
                        <span className="text-slate-400 normal-case tracking-normal">
                            (max QR {Number(displayAmount).toFixed(2)})
                        </span>
                    </label>
                    <input
                        type="number"
                        placeholder="0.00"
                        value={resPrice}
                        disabled={isZero}
                        onChange={(e) => onAmountChange(e.target.value)}
                        className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-400"
                    />
                </div>
                <Button label='Refund' className='w-20 h-fit end' disabled={!resPrice} onClick={onConfirm} />
            </div> : <div className='flex gap-2 justify-start items-end h-fit w-full'>

                <div className="flex flex-col gap-1.5 ">
                    <label className="text-[11px] text-slate-500 uppercase tracking-wider">
                        Amount{" "}
                        <span className="text-slate-400 normal-case tracking-normal">
                            (max QR {Number(balance || 0).toFixed(2)})
                        </span>
                    </label>
                    <input
                        type="number"
                        placeholder="0.00"
                        value={resPrice}
                        disabled={isZero}
                        onChange={(e) => onAmountChange(e.target.value)}
                        className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-400"
                    />
                </div>
                <Button label='Pay' className='w-20 h-fit end' disabled={!resPrice} onClick={onConfirm} />
            </div>}
        </div>
    )
}

export default RefundCard
